export default function tsCode(code) {
  return `
${'```ts'}
${code}
${'```'}
`;
}
//# sourceMappingURL=tsCode.js.map
